module.exports = __webpack_public_path__ + "img/pfc-thumb1.36468900.png";